import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let arr = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/pages/login/newLogin.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/oldLogin',
    name: 'login2',
    component: () => import('@/pages/login/login.vue'),
    meta: { title: '登录' }
  },
]
let newArr = [
  {
    path: '/newIndex',
    name: 'newIndex',
    component: () => import('@/pages/newPage/index.vue'),
    meta: { title: '父页面' },
    redirect: '/index/userInfo',
    children: [
      {
        path: '/index/userInfo', name: 'indexInfo', meta: { title: '账户信息' },
        component: () => import('@/pages/newPage/userInfo.vue'),
        redirect: '/index/userInfo/index',
        children: [
          {
            path: '/index/userInfo/index', name: 'userIndex', meta: { title: '账户信息' },
            component: () => import('@/pages/newPage/userInfo/uInfo.vue'),
          },
          {
            path: '/index/userInfo/welfare', name: 'userVipWelfare', meta: { title: '会员福利' },
            component: () => import('@/pages/newPage/userInfo/vipWelfare.vue'),
          },
          {
            path: '/index/userInfo/prop', name: 'userProp', meta: { title: '活动道具兑换' },
            component: () => import('@/pages/newPage/userInfo/prop.vue'),
          },
          {
            path: '/index/userInfo/new', name: 'userNew', meta: { title: '最新内容推送' },
            component: () => import('@/pages/newPage/userInfo/new.vue'),
          }
        ]
      },
      {
        path: '/index/binding', name: 'binDing', meta: { title: '账户换绑' },
        component: () => import('@/pages/newPage/binDing.vue')
      },
      {
        path: '/index/security', name: 'security', meta: { title: '安全设置' },
        component: () => import('@/pages/newPage/security.vue')
      },
      {
        path: '/index/chanPwd', name: 'chanPwd', meta: { title: '修改密码' },
        component: () => import('@/pages/newPage/chanPwd.vue')
      },
      {
        path: '/index/pLog', name: 'log', meta: { title: '日志详情' },
        component: () => import('@/pages/newPage/log.vue')
      },
      {
        path: '/index/exLog', name: 'exLog', meta: { title: '兑换记录' },
        component: () => import('@/pages/newPage/exLog.vue')
      },
      // {
      //   path: '/index/realNameRegis', name: 'realNameRegis', meta: { title: '实名认证' },
      //   component: () => import('@/pages/newPage/realNameRegis.vue')
      // },
      {
        path: '/index/userCance', name: 'userCance', meta: { title: '账号注销' },
        component: () => import('@/pages/newPage/userCance.vue')
      },
    ]
  }
]
let routesArr = [...arr, ...newArr]
const router = new Router({
  routes: routesArr
})
router.beforeEach((to, from, next) => {
  if (to.path == '/' || to.path == '/oldLogin') {
    next()
  } else if (to.path != '/' && localStorage.getItem('user')) {
    next()
  } else {
    next('/')
  }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js